// extracted by mini-css-extract-plugin
module.exports = {"descriptionContainer":"BundleProductDescription_descriptionContainer__RgA_k"};